import React from 'react';
import { Translations } from '../i18n/translations';
import { ShippingIcon, WhatsAppIcon } from './icons';
import { LogoCrown } from './Logo';
export const TrustStrip: React.FC<{
  t: Translations;
}> = ({
  t
}) => {
  const items = [{
    icon: <LogoCrown className="w-10 h-10" data-id="element-363" />,
    label: t.trust.postSurgery
  }, {
    icon: <ShippingIcon className="w-8 h-8" data-id="element-364" />,
    label: t.trust.shipping
  }, {
    icon: <LogoCrown className="w-10 h-10" data-id="element-365" />,
    label: t.trust.payment
  }, {
    icon: <WhatsAppIcon className="w-8 h-8" data-id="element-366" />,
    label: t.trust.guidance
  }];
  return <section className="bg-cream py-12 border-b border-gold/10" data-id="element-367">
      <div className="max-w-7xl mx-auto px-4 lg:px-8" data-id="element-368">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0" data-id="element-369">
          {items.map((item, i) => <div key={i} className={`flex flex-col items-center text-center space-y-4 ${i !== items.length - 1 ? 'lg:border-r lg:border-gold/30' : ''}`} data-id="element-370">
              <div className="text-gold" data-id="element-371">{item.icon}</div>
              <span className="text-xs uppercase tracking-widest text-ink/80 max-w-[150px] leading-relaxed" data-id="element-372">
                {item.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};